import { useEffect, useState } from "react";
import axios from "axios";
import { BarChart3, Newspaper } from "lucide-react";
import { useI18n } from "../i18n";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LinkIntelligence() {
  const { tr } = useI18n();
  const [desks, setDesks] = useState([]);
  const [scans, setScans] = useState(null);

  useEffect(() => {
    axios.get(`${API}/desks`).then((r) => setDesks(r.data)).catch(() => {});
    axios.get(`${API}/analytics/scans`).then((r) => setScans(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mt-10 grid lg:grid-cols-2 gap-6" data-testid="link-intelligence">
      <Reveal>
        <div className="border border-[#BFD4F2] rounded-3xl p-6 bg-white h-full" data-testid="country-desks-panel">
          <div className="flex items-center gap-2 font-extrabold text-[#0F2557]"><Newspaper size={17} className="text-[#2563EB]" /> {tr("Country Desk Aliases")}</div>
          <p className="text-xs text-[#64748B] mt-1.5">{tr("Reserved SpLink aliases for editors' bylines and regional coverage.")}</p>
          <div className="flex flex-wrap gap-2 mt-4">
            {desks.map((d) => (
              <a
                key={d.alias}
                data-testid={`desk-chip-${d.alias}`}
                href={d.short_url} target="_blank" rel="noreferrer"
                className={`font-mono-wp text-xs px-3 py-2 rounded-full border transition-colors ${d.reserved ? "border-[#86EFAC] bg-[#F0FDF4] text-[#15803D] hover:bg-[#DCFCE7]" : "border-[#E5EDF7] text-[#64748B]"}`}
                title={d.label}
              >
                splink.pro/{d.alias} {d.reserved ? "✓" : ""}
              </a>
            ))}
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="border border-[#D8CCF2] rounded-3xl p-6 bg-white h-full" data-testid="scan-analytics-panel">
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <div className="flex items-center gap-2 font-extrabold text-[#0F2557]"><BarChart3 size={17} className="text-[#7C3AED]" /> {tr("Scan Analytics")}</div>
            {scans?.last_csv_sync && <span className="text-[0.6rem] font-bold text-[#94A3B8]">{tr("Geo CSV synced")}: {new Date(scans.last_csv_sync).toLocaleString()}</span>}
          </div>
          <p className="text-xs text-[#64748B] mt-1.5">{tr("Per-place clicks from SpLink — which links travel furthest.")}</p>
          <div className="mt-4 space-y-2">
            {scans?.links?.slice(0, 6).map((l) => (
              <div key={l.slug} data-testid="scan-analytics-row" className="flex items-center gap-3 text-xs border-b border-[#F1F5F9] pb-2">
                <span className="font-mono-wp font-bold text-[#0F2557] w-32 truncate">splink.pro/{l.slug}</span>
                <span className="text-[#64748B] flex-1 truncate">{l.long_url.replace("https://worldpulse.pro", "")}</span>
                <span className="font-extrabold text-[#7C3AED]">{l.clicks} {tr("clicks")}</span>
                {l.top_countries?.length > 0 && <span className="text-[#64748B] hidden md:inline">{l.top_countries.map((c) => (typeof c === "string" ? c : c.country || c.name || "")).filter(Boolean).slice(0, 2).join(", ")}</span>}
              </div>
            ))}
            {scans && !scans.links?.length && <p className="text-xs text-[#94A3B8]">{tr("Analytics appear once links start being scanned.")}</p>}
          </div>
        </div>
      </Reveal>
    </div>
  );
}
